import { render, staticRenderFns } from "./conversion-test.vue?vue&type=template&id=35c96820&scoped=true"
import script from "./conversion-test.vue?vue&type=script&lang=js"
export * from "./conversion-test.vue?vue&type=script&lang=js"
import style0 from "./conversion-test.vue?vue&type=style&index=0&id=35c96820&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35c96820",
  null
  
)

export default component.exports